import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import formMapper from "@mappers/Clients/Hackatao/gridAvatars/GridAvatars.mapper";
import createGridAvatars from "@services/Clients/Hackatao/gridAvatars/createItem";
import FormValidator from "@validators/Clients/Hackatao/gridAvatars/GridAvatars.validate";
import CreateForm from "./CreateForm";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createGridAvatars}
    validator={FormValidator}
    formMapper={formMapper}
  />
);

export default CreateItem;
